module.exports = __webpack_public_path__ + "static/7-5ebd1a88fd7acd58789a9c852dd26f88.png";